import React from 'react';
import fscreen from '../../utils/fscreen';
import useFullScreenToggle from '../../hooks/useFullScreenToggle';
import { Logger } from '../../utils';

export default function ToggleFullscreenButton() {
    const [isFullScreen, toggleFullScreen] = useFullScreenToggle();
    const containerToFullScreen = document.getElementsByClassName("main-container");
    const elementToFullScreen = document && containerToFullScreen && containerToFullScreen.length !== 0 ? containerToFullScreen[0] : document.documentElement;
    
    const fullScreenbtnClick = () => {
        Logger(`UI.Twilio.Room.Fullscreen.${isFullScreen ? "Expanded" : "Reduced"}.Clicked`, new Date());        
        toggleFullScreen(elementToFullScreen);
    };

    return fscreen.fullscreenEnabled ? <React.Fragment>
        <button id="full-screen" type="button" className={`btn btn-sm`} onClick={fullScreenbtnClick}><span className={`${isFullScreen ? " icon-reduce" : " icon-expand"}`}  /></button>   
    </React.Fragment> : null;
}
